import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'male-pr',
	landing: {
		ids: ['loader-m'],
		route: {
			path: '/m-pr',
			name: 'male-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-male-pr-funnel',
		route: {
			path: '/m-pr/ob/:page(.*)?',
			name: 'male-pr',
		},
		slug: 'male-pr',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-m-pr',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-m'],
	},
}

export default appAreaConfig
